module.exports = __webpack_public_path__ + "static/Aniołek lub pastuszek adoracyjny-1aa19d1606de45ab51ae405cfa6af484.jpg";